import React, { useCallback } from 'react';
import cn from 'classnames';

import { ModalContext } from 'components/core/ModalRoot.component';
import MenuBanner from 'components/menu/MenuBanner.component';
import ReleaseInfoBox from 'components/menu/ReleaseInfoBox.component';
import RELEASE from 'config/release.singleton';
import { useTranslation } from 'providers/GILT.provider';
import { useTheme } from 'providers/Theme.provider';

import ConfirmationDialog from 'scheduler/components/ConfirmationDialog';

import CN from './ReleaseMenuBanner.module.scss';

export const ReleaseMenuBanner = () => {
  const { t } = useTranslation();
  const { isDarkMode } = useTheme();

  const handleLeft = useCallback((ev) => {
    RELEASE.reload();
    ev?.onRequestClose?.();
  }, []);

  const handleClick = useCallback(
    (ev) =>
      ev?.showModal?.(
        ({ onRequestClose }) => (
          <ConfirmationDialog
            onRequestClose={onRequestClose}
            title={t('composite.sidebarMenu.releaseInfoBox.title')}
            leftButtonText={t('composite.sidebarMenu.releaseInfoBox.reloadButton')}
            onLeft={() => handleLeft({ onRequestClose })}
            rightButtonText={t('common.buttons.ok')}
            onRight={onRequestClose}
            onCancel={onRequestClose}
          >
            <ReleaseInfoBox extended />
          </ConfirmationDialog>
        ),
        {},
      ),
    [handleLeft, t],
  );

  return (
    <MenuBanner>
      <ModalContext.Consumer>
        {({ showModal }) => (
          <div
            data-bem="ReleaseMenuBanner"
            className={cn({
              [CN.component]: true,
              [CN.darkMode]: isDarkMode,
            })}
            aria-current="true"
            role="link"
            tabIndex="0"
            onClick={() => void handleClick({ showModal })}
          >
            <span className={CN.textBold}>
              {t('composite.sidebarMenu.versionId')} <ReleaseInfoBox />
            </span>
          </div>
        )}
      </ModalContext.Consumer>
    </MenuBanner>
  );
};
